import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import { consumeTheme } from '../../utils/theme';
import Avatar from '../Avatar';
var Profile = (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, prefixCls = _a.prefixCls, className = _a.className, style = _a.style, avatarUrl = _a.avatarUrl, description = _a.description, type = _a.type, userName = _a.userName;
            var classes = classNames(prefixCls, className, prefixCls + "-" + type);
            return (h("div", { className: classes, style: style },
                h("div", { className: classNames(prefixCls + "-content") },
                    h(Avatar, { src: avatarUrl, footer: type, size: 48, radius: "4px" }),
                    h("span", { className: classNames(prefixCls + "-name") }, userName),
                    h("span", { className: classNames(prefixCls + "-desc") }, description))));
        };
        return _this;
    }
    Profile.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Profile;
}(React.Component));
export default Profile;
Profile.defaultProps = {
    prefixCls: 'dui-profile',
    type: 'qq',
};
